import React from 'react';
import PropTypes from 'prop-types';

function Settings({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 14a2 2 0 100-4 2 2 0 000 4z"
        clipRule="evenodd"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18.055 14.454a1.35 1.35 0 00.27 1.49l.049.049a1.636 1.636 0 11-2.316 2.315l-.049-.049a1.35 1.35 0 00-1.489-.27 1.35 1.35 0 00-.818 1.235v.14a1.636 1.636 0 11-3.273 0v-.074a1.35 1.35 0 00-.884-1.235 1.35 1.35 0 00-1.489.27l-.049.049a1.636 1.636 0 11-2.315-2.316l.049-.049a1.35 1.35 0 00.27-1.489 1.35 1.35 0 00-1.236-.818h-.139a1.636 1.636 0 110-3.273h.074a1.35 1.35 0 001.235-.884 1.35 1.35 0 00-.27-1.489l-.049-.049a1.636 1.636 0 112.316-2.315l.049.049a1.35 1.35 0 001.489.27h.065a1.35 1.35 0 00.819-1.236v-.139a1.636 1.636 0 013.272 0v.074a1.35 1.35 0 00.819 1.235 1.35 1.35 0 001.489-.27l.049-.049a1.636 1.636 0 112.315 2.316l-.049.049a1.35 1.35 0 00-.27 1.489v.065a1.35 1.35 0 001.235.819h.14a1.636 1.636 0 010 3.272h-.074a1.35 1.35 0 00-1.235.819z"
        clipRule="evenodd"
      />
    </svg>
  );
}

Settings.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Settings;
